import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CodeManagementModel } from 'shared/definition';
import { CodeTypeName } from 'shared/consts';

@Injectable({
    providedIn: 'root',
})
export class CodeManagementApiService {

    codeCache: { [key: string]: any; } = {};
    energyTypes: { [key: string]: any; } = {};

    constructor(private httpClient: HttpClient) {

    }

    baseUrl = `api/CodeManagement`;

    getCodeList(typeCode: string) {
        return this.httpClient.get<CodeManagementModel[]>(`${this.baseUrl}/GetCodeList/${typeCode}`);
    }

    setCodeCache(typeCode: string) {
        this.getCodeList(typeCode).subscribe(res => {
            this.codeCache[typeCode] = res.map(x => {
                return { key: x.key, value: x.value };
            });
            
            // if (typeCode == CodeTypeName.EnergyType) {
            //     res.forEach(x => { this.energyTypes[x.key] = x.value });
            // }
        });
    }
}
